class HomepageController {

  constructor(helperService) {
    'ngInject';
    Object.assign(this, { helperService });
  }

  $onInit() {
    this.helperService.shutdownIntercom();
  }

}

export default HomepageController;



// WEBPACK FOOTER //
// ./client/app/modules/site/homepage/homepage.controller.js